module.exports = __webpack_public_path__ + "static/media/editIcon.80255e16.png";